import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Avatar } from '@mui/material';
import Dropzone from "react-dropzone";
import UploadIcon from '@mui/icons-material/Upload';
import { Button, ButtonGroup } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import Snackbar from '@mui/material/Snackbar';
import { configAxios } from "../../../utils/ConfigAxios";
import { axiosFetch } from "../../../utils/AxiosFetch";
import { useDispatch } from "react-redux";
import { profile_details } from "../../../redux/actions/user.actions"
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  textAlign: "center",
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            left: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};


export default function ProfileImage(props) {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(props.openModal);
  const [image, setImage] = React.useState(props.profileImage);
  const [isUploading, setIsUploading] = React.useState(false);
  const [profileImageName, setProfileImageName] = React.useState("");
  const [originalImageName, setOriginalImageName] = React.useState("");
  const [isRemoveConfrm, setIsRemoveConfrm] = React.useState(false)

  const allowedTypes = ["image/jpeg", " image/jpg", " image/png", " image/svg"];

  const renderAcceptedFileTypes = () => {
    let typesStr = "";
    if (allowedTypes) {
      allowedTypes.forEach((type /*, index*/) => {
        typesStr += `${type}, `;
      });
    }

    return typesStr;
  };

  React.useEffect(() => {
    if (props.openModal) {
      setOpen(true);
    }
  }, [props.openModal]);

  React.useEffect(() => {
    if (props.profileImage) {
      setImage(props.profileImage)
    }

  }, [props.profileImage])

  const handleClose = () => {
    props.editImage();
    setOpen(false);
    setImage(props.profileImage)
    setIsUploading(false)
  };
  const uploadImage = (file) => {
    if (file && file[0]) {
      if (file[0].type.includes('image')) {
        setIsUploading(true)
        const formData = new FormData();
        formData.append("file", file[0], file[0].name);

        configAxios
          .post("/Uploads/profile/image", formData)
          .then((res) => {
            if (res.status === 200) {
              // setIsUploading(false)
              // setImage(res.data.profileImageName);
              setProfileImageName(res.data.profileImageName);
              setOriginalImageName(res.data.originalImageName);
              uploadProfileImage(res.data.profileImageName, "profilePhotoName");
              uploadProfileImage(res.data.originalImageName, "originalPhotoName");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      else{
        dispatch(SnackbarActions(true, "warning" , "Kindly upload .jpeg, .jpg ,jfif or png file"))
      }

    }
  };

  const handleRemove = () => {
    uploadProfileImage("", "profilePhotoName");
    uploadProfileImage("", "originalPhotoName");
    setImage("")
  }
  const uploadProfileImage = (img, fieldName) => {
    var req = {
      "TypeId": 1,
      "FieldName": fieldName,
      "Value": img,
      "ItemId": props.Id,
      "TableName": "EmployeeDetails"
    }
    axiosFetch({
      method: "POST",
      url: "/data/update",
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {
          if (res.data === "success") {
            dispatch(profile_details(props.Id))
            setIsUploading(false)
            setImage(img)
            setIsRemoveConfrm(false)
          }
        }
        if (res.status === 400) {
          dispatch(SnackbarActions(true, "error", "Something Went Wrong!"))
        }
        if (res.status === 401) {
          // navigate("/");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth="sm"
        maxWidth="sm"
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          AIHub Account
        </BootstrapDialogTitle>
        <DialogContent>
          {image === "" || image === null ?
            <div>
              <Dropzone
                disableClick={true}
                onDrop={(e) => uploadImage(e)}
                className="dropzone"
                activeClassName="active-dropzone"
                multiple={false}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div
                      {...getRootProps()}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <input {...getInputProps()} />

                      <p>
                        <Avatar
                          sx={{
                            width: 150,
                            height: 150,
                            padding: 2,
                            marginLeft: 25,
                            marginTop: 5,
                          }} />
                        <br />
                        Drag Image here
                        <br />-- OR --
                        <br />
                        <UploadIcon />Upload from Computer
                      </p>
                    </div>
                  </section>
                )}
              </Dropzone>

            </div> :
            <div>
              <Avatar
                sx={{
                  width: 150,
                  height: 150,
                  marginLeft: 25,
                  marginTop: 5,
                }}
                src={image ? `/api/uploads/image/show/${image}` : ''}
              />
              <br />
              {isRemoveConfrm ? "Remove Profile Image?" : ""}
              <br />
              <ButtonGroup variant="outlined" aria-label="outlined button group">
                {isRemoveConfrm ?
                  <>
                    <Button onClick={() => setIsRemoveConfrm(false)}>Cancel</Button>
                    <Button variant="contained" startIcon={<DeleteIcon />} onClick={() => handleRemove()}>Remove</Button></>
                  :
                  <>
                    <Button startIcon={<ModeEditIcon />} onClick={() => setImage("")}>Change</Button>
                    <Button startIcon={<DeleteIcon />} onClick={() => setIsRemoveConfrm(true)}>Remove</Button></>}
              </ButtonGroup>
            </div>}
          <Snackbar
            sx={{ bottom: { xs: 90, sm: 150 } }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={isUploading}
            message="Uploading Photo..."
          />

        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}